import i18n from '@service/I18nService';
import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useMutation } from 'react-query';

export const useV2FlatFlatContractInfo = () =>
  useMutation(async ({ lang, ...data }: { houseId: number; buildings?: number[]; lang?: string }) => {
    const res = await $api.post(
      stringifyUrl({
        url: '/v2/flat/flat-contract-info',
        query: { lang: lang || i18n.language?.toUpperCase() }
      }),
      data
    );

    return res.data;
  });
